export class ActiveClass {
  public static DASHBOARD = "Dashboard";
  public static HEARTBEAT = "Heartbeat";
  public static ERROR_ALARM = "Error_Alarm";
  public static USER = "User";
  public static CUSTOMER = "Customer";
  public static SUPER_ADMIN = "Super_Admin";
  public static ROLE = "Role";
  public static MANAGE_USER = "Manage_User";
  public static MANAGE_ROLE = "Manage_Role";
  public static NOTIFICATION_MANAGE = "Notification_Manage";
  public static NOTIFICATION_EMAIL_ACCOUNT = "Notification_Email_Account";
  public static SYSTEM_PASSWORD_POLICY = "System_Password_Policy";
  public static SYSTEM_SECURITY_POLICY = "System_Security_Policy";
  public static SETTING = "SETTING";
  public static MACHINE = "Machine";
  public static MACHINE_ERROR_TYPE = "Machine_Error_Type";
  public static TRANSACTION = "Transaction";
  public static BARCODE = "Barcode";
  public static ERROR = "Error";
  public static BARCODE_TEMPLATE = "Barcode_Template";
  public static CHANGE_LOCATION = "Change_Location";
  public static REPORT = "Report";
  public static PAYMENT_REPORT = "payment_Report";
  public static MACHINE_LOG = "Machine-log";
  public static MQTT_CONFIGURATION = "MQTT-Configuration";
  public static PLC_CONFIGURATION = "PLC-Configuration";
  public static MACHINE_BARCODE = "Machine_Barcode";
  public static PICKUP_ROUTE = "Pickup_Route";
  public static CURRENT_FULLNESS_LOG = "current-fullness-logs";
  public static SYSTEM_SPECIFICATION_DETAIL = "system-specification-detail";
  public static DONATION_TEMPLATE = "donation-template";
  public static QRCODE_TEMPLATE = "Qr-Code";
  public static EMPLOYEE = "Employee";
  public static NOTIFICATION_USER = "notification-user";
  public static ERRORCODEVIDEOS = "errorcode-videos";
  public static SYSTEM_SPECIFICATION = "system-specification";
}
